export var PASTE_TOOLBAR_CLASS = 'ak-editor-paste-toolbar';
export var PASTE_TOOLBAR_MENU_ID = 'ak-editor-paste-toolbar-item-dropdownList';
export var TEXT_HIGHLIGHT_CLASS = 'text-highlight';
export var PASTE_HIGHLIGHT_DECORATION_KEY = 'paste-highlight-decoration-key';
export var PASTE_TOOLBAR_ITEM_CLASS = 'ak-editor-paste-toolbar-item';
export var EDITOR_WRAPPER_CLASS = 'akEditor';
export var PASTE_OPTIONS_TEST_ID = 'paste-options-testid';
export var PASTE_OPTIONS_META_ID = 'paste-options$';